import { StaffPage } from '@features/staff-page/components/StaffPage'
import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/staff/$initials')({
    component: StaffPage,
    beforeLoad: requireRouteAudience(['staff']),
})